/*
  Cart-Upsell „Dazu passt" — Fitment-Kaskade.

  Füllt .t-cart-upsell__strip prioritär bis [data-target]:
    1) gewähltes Auto aus der Fahrzeug-Pill (TrautisFitment.get -> resolveFilterIds)
    2) Fitment der Warenkorb-Produkte ([data-cart-fitment-gids])
    3) server-gerenderte Basis-Karten (allg. Kollektion, bleiben als Schluss)
  Dedupt gegen [data-exclude] + [data-shown-handles] + bereits gezeigte; OOS raus.

  Karten kommen vom leichten View templates/collection.cart-upsell.liquid
  (/collections/all?view=cart-upsell&filter.p.m.custom.fitment_applications=<gid>).

  Lebenszyklus: init() verarbeitet vorhandene [data-cart-upsell] + installiert einen
  MutationObserver auf <cart-drawer>; cart.renderContents() ersetzt das Element bei
  jedem Cart-Change neu -> das frische [data-cart-upsell] wird erneut verarbeitet
  (Guard [data-upsell-processed] verhindert Doppel-Läufe pro Element).

  Eigene Leicht-Karte, kein Wishlist/Compat/Fitment-JS im Drawer.
*/
(function (root, factory) {
  var api = factory(typeof window !== 'undefined' ? window : null);
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (root) {
    root.TrautisCartUpsell = api;
    if (root.document && root.document.addEventListener) {
      if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', api.init);
      else api.init();
    }
  }
})(typeof window !== 'undefined' ? window : this, function (win) {
  'use strict';

  function parseCsv(str) {
    return (str || '').split(',').map(function (s) { return s.trim(); }).filter(function (s) { return s.length > 0; });
  }
  function csvSet(str) {
    var set = {}; parseCsv(str).forEach(function (h) { set[h] = true; }); return set;
  }
  function cells(el) {
    return el && el.querySelectorAll ? Array.prototype.slice.call(el.querySelectorAll('.t-cart-upsell__cell')) : [];
  }
  function handleOf(node) { return node && node.dataset ? node.dataset.productHandle : ''; }
  function isAvailable(node) { return !(node && node.dataset && node.dataset.available === 'false'); }

  function fetchCards(gids) {
    var url = '/collections/all?view=cart-upsell';
    gids.forEach(function (g) { url += '&filter.p.m.custom.fitment_applications=' + encodeURIComponent(g); });
    return win.fetch(url).then(function (r) { return r.text(); });
  }
  function cardsFrom(html) {
    return cells(new win.DOMParser().parseFromString(html, 'text/html'));
  }

  // Move fresh, available, unseen cards into `picks` until target reached. Returns count added.
  function take(nodes, seen, picks, target) {
    var added = 0;
    for (var i = 0; i < nodes.length && picks.length < target; i++) {
      var h = handleOf(nodes[i]);
      if (!h || seen[h] || !isAvailable(nodes[i])) continue;
      seen[h] = true;
      picks.push(nodes[i]);
      added++;
    }
    return added;
  }

  // Baureihe (Serie) aus dem Pill-Label ziehen — Kunde will nur „2er", NICHT
  // „2er · F23 · B58". Voll-Label = „Serie · Chassis · Motor" (3 Teile, vom Modal
  // via formatLabel) → Teil 1 ist die Baureihe. Minimal-Label (?bmw=-Deeplink) =
  // „Chassis · Motor" (2 Teile) → keine Baureihe bekannt → Default-Überschrift.
  function seriesLabel(vehicle) {
    if (!vehicle || !vehicle.label) return '';
    var parts = vehicle.label.split('·').map(function (s) { return s.trim(); }).filter(function (s) { return s.length; });
    return parts.length >= 3 ? parts[0] : '';
  }

  function setHeading(container, vehicle, vehicleHit) {
    var h = container.querySelector('[data-cart-upsell-heading]');
    if (!h) return;
    var def = container.dataset.headingDefault || 'Vielleicht auch interessant';
    var series = vehicleHit ? seriesLabel(vehicle) : '';
    h.textContent = series ? ('Passend für deinen ' + series) : def;
  }

  function process(container) {
    if (!container || (container.dataset && container.dataset.upsellProcessed === '1')) return Promise.resolve();
    if (container.dataset) container.dataset.upsellProcessed = '1';
    var strip = container.querySelector('[data-cart-upsell-strip]');
    if (!strip) return Promise.resolve();

    var target = parseInt(container.dataset.target, 10);
    if (!target || target < 1) target = 6;

    var seen = csvSet(container.dataset.exclude);
    parseCsv(container.dataset.shownHandles).forEach(function (h) { seen[h] = true; });

    // Basis = server-gerenderte Karten (Priorität 3, bleiben am Ende). Als gesehen merken.
    var baseline = cells(strip);
    baseline.forEach(function (n) { var h = handleOf(n); if (h) seen[h] = true; });

    var TF = win.TrautisFitment;
    var vehicle = (TF && typeof TF.get === 'function') ? TF.get() : null;
    var cartGids = parseCsv(container.dataset.cartFitmentGids);

    var vehicleGidsP = (vehicle && vehicle.chassis && vehicle.engine && TF && TF.resolveFilterIds)
      ? TF.resolveFilterIds(vehicle.chassis, vehicle.engine).catch(function () { return []; })
      : Promise.resolve([]);

    return vehicleGidsP.then(function (vGids) {
      var picks = [];        // prioritäts-geordnete frische Knoten (Auto, dann Cart-Fitment)
      var vehicleHit = false;
      var chain = Promise.resolve();

      if (vGids && vGids.length) {
        chain = chain.then(function () { return fetchCards(vGids); }).then(function (html) {
          if (take(cardsFrom(html), seen, picks, target) > 0) vehicleHit = true;
        }).catch(function () {});
      }
      if (cartGids.length) {
        chain = chain.then(function () {
          if (picks.length >= target) return;
          return fetchCards(cartGids).then(function (html) { take(cardsFrom(html), seen, picks, target); }).catch(function () {});
        });
      }

      return chain.then(function () {
        // Prioritäts-Picks vor die Basis einfügen.
        var firstBaseline = baseline.length ? baseline[0] : null;
        picks.forEach(function (node) { strip.insertBefore(node, firstBaseline); });
        // Gesamtzahl auf target trimmen — Überschuss vom Ende (Basis zuerst).
        var all = cells(strip);
        for (var i = all.length - 1; i >= target; i--) { if (all[i].remove) all[i].remove(); }
        // Kein echte Karte übrig -> Strip/Container entfernen.
        if (cells(strip).length === 0) { if (container.remove) container.remove(); return; }
        setHeading(container, vehicle, vehicleHit);
      });
    });
  }

  var observer = null;
  function processAll() {
    var nodes = (win.document && win.document.querySelectorAll) ? win.document.querySelectorAll('[data-cart-upsell]') : [];
    for (var i = 0; i < nodes.length; i++) process(nodes[i]);
  }
  function init() {
    if (!win.document) return;
    processAll();
    // Drawer-Re-Render ersetzt das [data-cart-upsell]-Element -> neu verarbeiten.
    var drawer = win.document.querySelector ? win.document.querySelector('cart-drawer') : null;
    if (drawer && win.MutationObserver && !observer) {
      observer = new win.MutationObserver(function () { processAll(); });
      observer.observe(drawer, { childList: true, subtree: true });
    }
  }

  return { init: init, process: process };
});
